import { WorkRequestType } from '@prisma/client';

export class WorkRequestHelper {
  static INCORPORATION_WORK_REQUEST_TYPES: WorkRequestType[] = [
    WorkRequestType.AEIncorporation,
    WorkRequestType.GBIncorporation,
    WorkRequestType.SGIncorporation,
    WorkRequestType.IEIncorporation,
    WorkRequestType.USIncorporation,
    WorkRequestType.LLCFormation,
    WorkRequestType.INIncorporation,
    WorkRequestType.INLLPFormation,
    WorkRequestType.CAIncorporation,
  ];

  static isIncorporationWorkRequest(workRequestType: WorkRequestType) {
    return this.INCORPORATION_WORK_REQUEST_TYPES.includes(workRequestType);
  }

  static getIncorporationWorkRequestLink(
    workRequestType: WorkRequestType,
    workRequestId: string
  ) {
    if (workRequestType === WorkRequestType.GBIncorporation)
      return `/incorporate/gb/${workRequestId}`;
    else if (workRequestType === WorkRequestType.SGIncorporation)
      return `/incorporate/sg/${workRequestId}`;
    else if (workRequestType === WorkRequestType.AEIncorporation)
      return `/incorporate/ae/${workRequestId}`;
    return null;
  }
}
